// Inspections API service - calls /api/inspections endpoints
import { apiService } from './api';
import {
  Inspection,
  InspectionCreate,
  InspectionUpdate,
  InspectionTask,
  InspectionTaskCreate,
  InspectionTaskUpdate,
  Task,
  InspectionFilters,
  PaginationParams
} from '../types';

/**
 * Service for managing inspections via the /api/inspections endpoints.
 * Tasks are auto-generated when an inspection is created.
 */
export class InspectionsService {
  async getInspections(params?: InspectionFilters): Promise<Inspection[]> {
    return apiService.get<Inspection[]>('/inspections/', params);
  }

  async getInspectionById(id: string): Promise<Inspection> {
    return apiService.get<Inspection>(`/inspections/${id}`);
  }

  async createInspection(inspectionData: InspectionCreate): Promise<Inspection> {
    return apiService.post<Inspection>('/inspections/', inspectionData);
  }

  async updateInspection(id: string, inspectionData: InspectionUpdate): Promise<Inspection> {
    return apiService.put<Inspection>(`/inspections/${id}`, inspectionData);
  }

  async deleteInspection(id: string): Promise<void> {
    return apiService.delete<void>(`/inspections/${id}`);
  }

  async getInspectionTasks(
    inspectionId: string,
    params?: PaginationParams
  ): Promise<Task[]> {
    return apiService.get<Task[]>(`/inspections/${inspectionId}/tasks`, params);
  }

  async regenerateInspectionTasks(inspectionId: string): Promise<Task[]> {
    return apiService.post<Task[]>(`/inspections/${inspectionId}/regenerate-tasks`);
  }

  async createInspectionTask(taskData: InspectionTaskCreate): Promise<InspectionTask> {
    return apiService.post<InspectionTask>('/tasks/inspection', taskData);
  }

  async updateInspectionTask(taskId: string, taskData: InspectionTaskUpdate): Promise<InspectionTask> {
    return apiService.put<InspectionTask>(`/tasks/inspection/${taskId}`, taskData);
  }

  async getInspectionTask(taskId: string): Promise<InspectionTask> {
    return apiService.get<InspectionTask>(`/tasks/inspection/${taskId}`);
  }

  async deleteInspectionTask(taskId: string): Promise<void> {
    return apiService.delete<void>(`/tasks/inspection/${taskId}`);
  }
}

export const inspectionsService = new InspectionsService();
